export default "__VITE_ASSET__CwRgsd6K__"